package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.pages.components.demo.AlertDemo
import example.shadcn_kotlin.ui.pages.components.demo.AlertDestructive

@Page
@Composable
fun AlertPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/alert.md", mapOf("title" to listOf("Alert"), "description" to listOf("Displays a callout for user attention.")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            ComponentPreview("""import lucide_react.Terminal
import react.FC
import react.Props
import shadcn.ui.components.Alert
import shadcn.ui.components.AlertDescription
import shadcn.ui.components.AlertTitle
import web.cssom.ClassName

val AlertDemo = FC<Props> {
    Alert {
        Terminal { className = ClassName("h-4 w-4") }
        AlertTitle { + "Heads up!" }
        AlertDescription { + "All components are published in a single library." }
    }
}"""){ 
 AlertDemo {} 
 }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("usage")
 }) {
                org.jetbrains.compose.web.dom.Text("Usage")
            }
            CodeBlock("""import shadcn.ui.components.Alert
import shadcn.ui.components.AlertDescription
import shadcn.ui.components.AlertTitle
""", lang= "kotlin", highlight= "")
            CodeBlock("""Alert {
    Terminal { className = ClassName("h-4 w-4") }
    AlertTitle { +"Heads up!" }
    AlertDescription { +"All components are published in a single library." }
}
""", lang= "kotlin", highlight= "")
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("examples")
 }) {
                org.jetbrains.compose.web.dom.Text("Examples")
            }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("default")
 }) {
                org.jetbrains.compose.web.dom.Text("Default")
            }
            ComponentPreview("""import lucide_react.Terminal
import react.FC
import react.Props
import shadcn.ui.components.Alert
import shadcn.ui.components.AlertDescription
import shadcn.ui.components.AlertTitle
import web.cssom.ClassName

val AlertDemo = FC<Props> {
    Alert {
        Terminal { className = ClassName("h-4 w-4") }
        AlertTitle { + "Heads up!" }
        AlertDescription { + "All components are published in a single library." }
    }
}"""){ 
 AlertDemo {} 
 }
            org.jetbrains.compose.web.dom.H3({ 
classes("font-heading","mt-8","scroll-m-20","text-xl","font-semibold","tracking-tight")
id("destructive")
 }) {
                org.jetbrains.compose.web.dom.Text("Destructive")
            }
            ComponentPreview("""import lucide_react.AlertCircle
import react.FC
import react.Props
import shadcn.ui.components.Alert
import shadcn.ui.components.AlertDescription
import shadcn.ui.components.AlertTitle
import web.cssom.ClassName

val AlertDestructive = FC<Props> {
    Alert {
        variant = "destructive"
        AlertCircle { className = ClassName("h-4 w-4") }
        AlertTitle { + "Error" }
        AlertDescription { + "Your session has expired. Please log in again." }
    }
}"""){ 
 AlertDestructive {} 
 }
        }
    }
}
